import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@banyan/commons/components/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cart-empty',
  templateUrl: './cart-empty.component.html',
  styleUrls: ['./cart-empty.component.scss'],
  standalone: true,
  imports: [
    TranslatePipe,
    ButtonComponent,
    RouterLink,

  ],
})
export class CartEmptyComponent {
}
